module.exports = __webpack_public_path__ + "static/img/football.3808f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/football.png
// module id = s94E
// module chunks = 20